import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Checkout/ECornerPayment/eCornerPayment.container"
    ).then((module) => ({ default: module.ECornerPayment }))
);
